/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import Icon from "../common_components/Icon";
import clsx from "clsx";
import { useHistory } from "react-router-dom";
import NotificationsIndicator from "components/Home/Notifications/Indicator";

function MenuItem({ id, label, path, icon, notificationsKeyIdentity, selected, onClick, betaFeature = false }) {
    const history = useHistory();

    return (
        <div
            className={clsx("nav-item", {
                "nav-item--active": selected,
                "nav-item--with-notifications": Boolean(notificationsKeyIdentity),
            })}
            disabled={!path}
            selected={selected}
            onClick={() => {
                onClick();
                history.push(path);
            }}
        >
            <div className="nav-item__icon">
                <Icon name={icon} color="white" />
            </div>
            <div className="nav-item__name hide-nav-small">{label}</div>
            {betaFeature && <Icon name="beta" color="white" size="xlg" />}
            <NotificationsIndicator id={`menu-item-${id}`} identity={notificationsKeyIdentity} className="in-menu" />
        </div>
    );
}

export default MenuItem;
